import React from 'react';
import {
  Box,
  Typography,
  Button,
  Chip,
  useMediaQuery,
} from '@mui/material';
import ReactPlayer from 'react-player' // react video player
import determineFileType from 'src/screens/Partners/Courses/hook/checkfileType';
import { makeStyles } from '@mui/styles';
import { ArrowForward, StarBorder, ArrowBack } from '@mui/icons-material';
import useServiceCard from '../../shared/logic/useServiceCard';
import { theme } from '../Template';
import { Rating } from '@mui/material';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import { useCompanyData } from '../../shared/contexts/DataContext';
import NoImage from 'src/assets/images/no-pictures.png';
import { extractContent } from '../../shared/logic/Utils';
import { textVariant, textClasses } from '../../shared/config';

const useStyles = makeStyles(() => ({
  readMore:{
    transition:'6s',
    backgroundColor:'transparent',
    "&:hover":{
      color:"#fac400"
    }
  },

  mainComp:props => ({
    boxShadow: props.shadow ? props?.shadow : '0px 0px 30px rgb(209,209,209)',
    "-webkit-box-shadow": props.shadow ? props?.shadow : '0px 0px 30px rgb(209,209,209)',
    "-moz-box-shadow": props.shadow ? props?.shadow : '0px 0px 30px rgb(209,209,209)',
    backgroundColor:'#fff',
    width:'100%',
    maxWidth:'400px',
    minWidth:'400px',
    backgroundColor:'#fff',
  
    '@media (max-width: 900px)': {
      maxWidth:'320px',
      minWidth:'320px',
    },
    
    '@media (max-width: 768px)': {
      maxWidth:'100%',
      minWidth:'100%'
    },
  }),

  root:{
    fontSize:'1.2rem !important'
  },

  iconFilled:{
    color: '#fac400 !important',
  },

  iconHover:{
    color: '#fac400',
  },

  iconEmpty:{
    color: '#fac400 !important',
  },

  icon:{
    display:'unset !important'
  },

    reactPlayer:{
        width:'100% !important',
        height:'100% !important',
        borderRadius:'10px',
        "& video":{
            width:'100% !important',
            height:'100% !important',
            objectFit:'cover',
            borderRadius:'10px',
        },
        "& iframe":{
            borderRadius:'10px',
        },

        '&.react-player__preview':{
            borderRadius:'10px'
        }
    },
}));


const CourseCard = ({ service,displayDescription,productType, companyId,contentData }) => {
  const { data } = useCompanyData();
  const { t, fontFamily, isRTL, mainColor, buttonColor, buttonFontColor } = data || {};
  const matches = useMediaQuery(theme.breakpoints.down('lg'));
  const { courseHandleClick, rating, reviews } = useServiceCard({service,productType,companyId});
  const maxStringLength = matches ? 80 : 130;
  const classes = useStyles({shadow:contentData?.shadow,defaultShadow:'none'});

  const shortDescription = extractContent(service?.description);

  const fileType = determineFileType(service?.cover);

  const cardRadius = contentData?.cardRadius ? `${contentData?.cardRadius}px` : '0px'; 
  const cardBorder = contentData?.border || 'none'; 

  const titleFontSize = contentData?.cardTitleFontSize ? contentData?.cardTitleFontSize : '21';
  const descriptionFontSize = contentData?.cardTextFontSize ? contentData?.cardTextFontSize : '14';

  const titleFontColor = contentData?.cardTitleColor ? contentData?.cardTitleColor : '';
  const descFontColor = contentData?.cardTextColor ? contentData?.cardTextColor : '';

  // button
  const _buttonColor = contentData?.buttonColor ? contentData?.buttonColor : buttonColor ? buttonColor : 'inherit';
  const _buttonFontColor = contentData?.buttonFontColor ? contentData?.buttonFontColor : buttonFontColor ? buttonFontColor : 'inherit';
  const _buttonFontSize = contentData?.buttonFontSize ? contentData?.buttonFontSize : '14';
  const _buttonWidth = contentData?.autoButtonSize ? 'fit-content' : contentData?.buttonWidth ? `${contentData?.buttonWidth}px` : 'fit-content';
  const _buttonHeight = contentData?.autoButtonSize ? 'unset' : contentData?.buttonHeight ? `${contentData?.buttonHeight}px` : 'unset';
  const btnRadius = contentData?.buttonRadius ? `${contentData?.buttonRadius}px` : '0px'; 

  return (
    <Box
      onClick={courseHandleClick}
      mx='18px'
      my='30px'
      dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
      className={classes.mainComp}
      style={{
        cursor: 'pointer',
        ...((contentData?.cardBackgroundStyle === 'image' && contentData?.cardBackgroundImage) ? 
          {
              backgroundSize: "cover",
              backgroundImage: `url(${contentData?.cardBackgroundImage})`,
              backgroundRepeat: "no-repeat",
          } 
        : 
        (contentData?.cardBackgroundStyle === 'gradient' && contentData?.cardBackgroundColor) ? 
          {
              backgroundImage: contentData?.cardBackgroundColor ? contentData?.cardBackgroundColor : '#ffffff',
          } 
        :
        (contentData?.cardBackgroundStyle === 'solidColor' && contentData?.cardBackgroundColor) ? 
          {
              backgroundColor: contentData?.cardBackgroundColor || '#ffffff',
          } 
        : 
          {backgroundColor: 'transparent'}
        ),
        overflow:'hidden'
      }}
      border={cardBorder}
      borderRadius={cardRadius}
    >

        <Box width="100%" height="260px" position="relative">
            {fileType === 'video' ?
            <>
                <ReactPlayer url={service.cover}
                className={classes.reactPlayer} />
            </>
            :
            <ImgLazyLoad>
                <img
                    style={{ width: '100%', height: '100%', objectFit: 'fill' }}
                    src={service?.cover || NoImage}
                    alt={service?.name || 'course'}
                />
            </ImgLazyLoad>
            }
        <Box
          position="absolute"
          width="100%"
          height="30px"
          bottom={0}
          left={0}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          color="white"
          py={1}
          bgcolor="rgba(17, 7, 41,0.8)"
        >
          {productType === 'categories' ?
            null
            :
            <>
            <div style={{display:'flex',flexDirection:'row',alignItems:'center',padding:'5px 5px'}}>
              <Rating
                classes={{root:classes.root,iconHover:classes.iconHover,iconFilled:classes.iconFilled,icon:classes.icon,iconEmpty:classes.iconEmpty}}
                name="half-rating-read"
                value={Number(rating)}
                precision={0.1}
                readOnly
                emptyIcon={<StarBorder fontSize="inherit" />}
              />
              <span style={{margin: '0 0.5em',color: '#fff',fontSize:'12px',fontFamily}}>{t('service.review',{count:reviews})}</span>
            </div>
            </>
          }

          <Typography
            component="p"
            variant="subtitle2"
            style={{
              textTransform: 'capitalize',
              width: 'fit-content',
              padding: '0 1em',
              fontSize:'12px'
            }}
          >
            {service?.serviceCategory}
          </Typography>
        </Box>
      </Box>
      <Box height="170px" py='25px' px='25px' position="relative">
        <Typography variant={textVariant?.[titleFontSize]} className={`twoLineTxt ${textClasses?.[titleFontSize]}`} style={{ fontWeight: 700,textTransform:'capitalize',...(titleFontColor ? {color:titleFontColor} : {}) }}>
          {service.enName}
        </Typography>

        { displayDescription ?
        <Box>
          <Typography variant={textVariant?.[descriptionFontSize]} style={{ opacity: '0.7',...(descFontColor ? {color:descFontColor} : {}) }} className={`twoLineTxt ${textClasses?.[descriptionFontSize]}`}>
            {shortDescription?.substring(0, maxStringLength)}
            {shortDescription  ? shortDescription?.length > maxStringLength && '...' : ''}
          </Typography>
        </Box>
        : null }

        <Box style={{display:'flex',flexDirection:'column',position:'absolute',bottom:'16px',...(isRTL === 'ar' ? {left:'16px'} : {right:'16px'})}}>
          <Button
            onClick={courseHandleClick}
            variant="text"
            className={`${classes.readMore} ${textClasses?.[_buttonFontSize]}`}
            style={{
              backgroundColor: _buttonColor,
              textTransform:'capitalize',
              color: _buttonFontColor,
              width: _buttonWidth,
              height: _buttonHeight,
              borderRadius: btnRadius,
              ...(contentData?.buttonBorder ? {border:contentData?.buttonBorder} : {})
            }}
            endIcon={
              isRTL === 'en' ? (
                <ArrowForward
                  style={{ fontSize: '1.2rem', margin: '0 0.2em' }}
                />
              ) : (
                <ArrowBack
                  style={{ fontSize: '1.2rem', margin: '0 0.2em' }}
                />
              )
            }
          >
            {t && t('companyPage.readMore')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CourseCard;